import { MBImage } from '@shared/components/image';
import { Signature, SignatureField } from '@shared/data/entity/fields/SignatureField';
import { useImageSrcAndDimensions } from '@shared/util/hooks';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: SignatureField;
}

export function SignatureCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <SignatureImage image={field.signature} />
    </CardCollectionViewFieldContainer>
  );
}

function SignatureImage({ image }: { image: Signature }) {
  const { src } = useImageSrcAndDimensions({ image });
  return <MBImage source={{ uri: src }} style={{ height: 30, width: 163.5 }} />;
}
